import { render, staticRenderFns } from "./checkout-logo.vue?vue&type=template&id=3b3a4a46&"
import script from "./checkout-logo.vue?vue&type=script&lang=js&"
export * from "./checkout-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports